import {useRouter} from 'vue-router';
import {useStore} from '@/helpers/store-effect';

export function useFocus(initialReset = false) {
    const router = useRouter();
    const store = useStore();

    const resetFocus = () => {
        store.expandedNode = null;
        store.currentActiveNodes = [];

        router.push({
            name: 'editor',
            params: {uid: store.workflow.uid},
        });
    };

    const setFocus = (node) => {
        if (node.type === 'branch') {
            store.currentActiveNodes = [node.uid, ...node.children.map(childNode => childNode.id)];
        } else {
            store.currentActiveNodes = [node.uid];
        }

        router.push({
            name: 'nodeSettings',
            params: {nodeUid: node.uid},
        });
    };

    if (initialReset) {
        store.expandedNode = null;
        store.currentActiveNodes = [];
    }

    return {
        setFocus,
        resetFocus,

        get currentActiveNodes() {
            return store.currentActiveNodes;
        },
    };
}
